import { translate } from "app/filters/i18nFilter";
import { REST_OF_WORLD_COUNTRY_ID } from "app/pages/sales-intelligence/sub-modules/intent/constants/countries";
import type { IntentCountry } from "app/pages/sales-intelligence/sub-modules/intent/types/dto";
import type { ICountryObject } from "app/services/CountryService";
import CountryService from "app/services/CountryService";

const getTooltipText = (countryCode: number): string | undefined => {
    if (countryCode === REST_OF_WORLD_COUNTRY_ID)
        {return translate("si.signals.filters.countries-intent.country.other.text");}
};

export const mapCountriesToCountryObjects = (
    countries: readonly IntentCountry[] | undefined,
): readonly ICountryObject[] => {
    return (countries ?? []).map(({ country, countryCode }): ICountryObject => {
        const supportedCountry: ICountryObject | undefined = CountryService.getCountryById(countryCode);

        return (
            supportedCountry ?? {
                id: countryCode,
                code: countryCode.toString(),
                text: country,
                tooltipText: getTooltipText(countryCode),
            }
        );
    });
};
